import {List, Map} from "immutable";

// What a manifest adds up to: per SKU, its total quantity across pallets and
// the quantity received. Received quantities are recorded per SKU, and every
// line of that SKU carries the same figure, so it is taken once rather than
// summed.
export function summariseSkus(lines) {
  return (lines || List())
    .groupBy((line) => line.get("sku"))
    .map((group) => ({
      quantity: group.reduce((sum, line) => sum + (line.get("quantity") || 0), 0),
      received: group.first().get("receivedQuantity"),
    }))
    .sortBy((_totals, sku) => sku);
}

// The same totals as rows for an InlineTable (`sku`, `quantity`,
// `receivedQuantity`), ending with a Total row.
export function skuSummaryRows(lines) {
  const bySku = summariseSkus(lines);
  if (bySku.size === 0) return List();
  const rows = bySku.entrySeq().map(([sku, totals]) => Map({sku, quantity: totals.quantity, receivedQuantity: totals.received})).toList();
  return rows.push(Map({
    sku: "Total",
    quantity: bySku.reduce((sum, totals) => sum + totals.quantity, 0),
    receivedQuantity: bySku.reduce((sum, totals) => sum + (totals.received || 0), 0),
  }));
}
